import { Box, SxProps } from "@mui/material";
import React from 'react'
import { colors } from "../../common/colors";
import Button from "../../components/SubmitButton";

interface Props {
  title: string;
  sx?: SxProps;
  validate?: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>;
}

const FetchButton: React.FC<Props> = ({ title, sx, validate, onSubmit }) => {
  return (
    <Box sx={{ ...styles.container, ...sx }}>
      <Button
        size={"small"}
        variant="contained"
        sx={styles.button}
        onSubmit={onSubmit}
        validate={async () => {
          return validate ? await validate() : true
        }}
      >
        {title}
      </Button>
    </Box>
  );
}
export default FetchButton;

const styles = {
  container: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 1
  },
  button: {
    margin: 1,
    backgroundColor: colors.farm_blue200,
    color: colors.farm_white
  }
}
